import { Button, Typography } from '@material-ui/core'
import { useLocation } from 'react-router'
import OauthLogin from './OauthLogin'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/client'
import styles from "./index.module.css"

export const GET_CLIENT_ID = gql`
query GetClientId {
  clientId
}
`

const allScopes = [
    "chlorinestation.dispense-self",
    "chlorinestation.dispense-external",
    "chlorinestation.see-logs",
    "chlorinestation.use-virtual-keypad"
]

export default function Login({ setToken }: { setToken: (token: string, scope: string[]) => void }) {
    const { data } = useQuery(GET_CLIENT_ID)
    const location = useLocation()

    const redirectUrl = new URL("/oauthlogin", window.location.origin)
    const oauthUrl = new URL("https://sso.a-qualitypools.net/oauth/authorize")
    oauthUrl.searchParams.append("response_type", "code")
    oauthUrl.searchParams.append("client_id", data?.clientId)
    oauthUrl.searchParams.append("scope", allScopes.join(' '))
    oauthUrl.searchParams.append("redirect_uri", redirectUrl.toString())

    if (location.pathname === "/oauthlogin") {
        return (
            <OauthLogin setToken={setToken} />
        )
    }

    return (
        <div className={styles.login_page}>
            <img src="/img/logo.png" alt="" />
            <Typography variant="h2" align="center">Chlorine</Typography>
            <Button size="large" variant="contained" color="primary" component="a" href={oauthUrl.toString()} disabled={data == null}>Login</Button>
        </div>
    )
}
